import { useParams } from "react-router-dom";
import { Page, Text, View, Document } from "@react-pdf/renderer";
import { useFindById } from "../../server/hooks/getData";
import { Viewer } from "../lib/PdfViewer";
import { styles } from "./styles";
import { worksheet } from "./workSheetStyle";
import { numToHuf } from "../../lib/currencyFormatter";
import { formatDate } from "../../lib/dateHelper";

// Create Document Component
export default function Worksheet() {
  const id = useParams().id || "";
  const { data: job, loading } = useFindById("jobs", [], id);

  const page = (
    <Page size="A4" style={styles.page}>
      <View>
        <View style={[styles.row, worksheet.header]}>
          <Text style={[styles.fs_1]}>MUNKALAP</Text>
          <Text>
            <Text style={styles.fs_2}>Munkaszám: </Text>
            <Text style={[styles.fs_1]}>{`${job.job_number_prefix ?? ""}${job.job_number}`}</Text>
          </Text>
        </View>
      </View>
      <View style={[styles.row, worksheet.section]}>
        <View style={styles.col}>
          <Text style={worksheet.title}>Megrendelő:</Text>
          <View style={styles.row}>
            <View style={styles.col_3}>
              <View style={{ fontStyle: "italic" }}>
                <Text>Név:</Text>
                <Text>Cím:</Text>
                <Text>Adószám:</Text>
              </View>
            </View>
            <View style={styles.col_7}>
              <View>
                <Text>{job.client_name}</Text>
                <Text>{`${job.client_zip} ${job.client_city}, ${job.client_street}`}</Text>
                <Text>{job.client_vat || ""}</Text>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.col}>
          <Text style={worksheet.title}>Kapcsolattartó:</Text>
          <View style={styles.row}>
            <View style={styles.col_3}>
              <View style={{ fontStyle: "italic" }}>
                <Text>Név:</Text>
                <Text>Telefon:</Text>
                <Text>E-mail:</Text>
              </View>
            </View>
            <View style={styles.col_7}>
              <View>
                <Text>{job.contact_name}</Text>
                <Text>{job.contact_phone}</Text>
                <Text>{job.contact_email}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={[styles.row, worksheet.section]}>
        <View style={styles.col}>
          <Text style={worksheet.title}>Eszköz:</Text>
          <View style={styles.row}>
            <View style={styles.col_3}>
              <View style={{ fontStyle: "italic" }}>
                <Text>Típus:</Text>
                <Text>Gyártó:</Text>
                <Text>Megnevezés:</Text>
                <Text>Gyáriszám:</Text>
                <Text>Leadott tartozékok:</Text>
              </View>
            </View>
            <View style={styles.col_7}>
              <View>
                <Text>{job.device}</Text>
                <Text>{job.device_manufacturer}</Text>
                <Text>{job.device_description}</Text>
                <Text>{job.serial_no}</Text>
                <Text>{job.accessories || "-"}</Text>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.col}>
          <Text style={worksheet.title}>Információk:</Text>
          <View style={styles.row}>
            <View style={styles.col_3}>
              <View style={{ fontStyle: "italic" }}>
                <Text>Kalibrálás:</Text>
                <Text>Minősítés:</Text>
                <Text>Javítás:</Text>
                {job.warranty && <Text>Garanciális:</Text>}
                <Text>Hibaleírás:</Text>
                <Text>Megjegyzés:</Text>
              </View>
            </View>
            <View style={styles.col_7}>
              <View>
                <Text>{job.calibration ? "X" : "-"}</Text>
                <Text>{job.qualify ? "X" : "-"}</Text>
                <Text>{job.repair ? "X" : "-"}</Text>
                {job.warranty && <Text>{job.warranty ? "X" : "-"}</Text>}
                <Text>{job.fault_description || "-"}</Text>
                <Text>{job.job_note || "-"}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={[styles.row, worksheet.section]}>
        <View style={styles.col_7}>
          <Text style={worksheet.title}>Várható költségek:</Text>
          <View style={styles.row}>
            <View style={styles.col_3}>
              <View style={{ fontStyle: "italic" }}>
                <Text>Kalibrálás:</Text>
                <Text>Minősítés:</Text>
                <Text>Javítás:</Text>
                <Text>Bevizsgálás:</Text>
              </View>
            </View>
            <View style={styles.col_7}>
              <View>
                <Text>{numToHuf(job.cal_price)}</Text>
                <Text>{numToHuf(job.qualify_price)}</Text>
                <Text>{numToHuf(job.repair_price)}</Text>
                <Text>{numToHuf(job.examination_price)}*</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
      <View style={{ fontSize: 10, marginTop: 5 }}>
        <Text>A készrejelentést követő 10 naptári nap után 1000 Ft/nap tárolási díjat számolunk fel!</Text>
      </View>
      <View>
        <Text style={{ marginTop: 15, textDecoration: "none" }}>Dátum: {formatDate(job.date)}</Text>
      </View>
      <View style={[styles.row, { marginTop: 100 }]}>
        <View style={styles.col}>
          <Text style={[worksheet.title, { borderTop: 1, borderStyle: "dashed", marginRight: 30 }]}>Megrendelő</Text>
        </View>
        <View style={styles.col}>
          <Text style={[worksheet.title, { borderTop: 1, borderStyle: "dashed", marginRight: 30 }]}>Szolgáltató</Text>
        </View>
      </View>
      <View style={worksheet.footer}>
        <Text style={{ fontSize: 10, marginTop: 5 }}>A feltüntetett árak az ÁFÁ-t nem tartalmazzák.</Text>
        <Text style={{ fontSize: 10, marginTop: 2 }}>
          *A bevizsgálás költségét csak abban az esetben szükséges megfizetni, amennyiben nem kérik a javítást, vagy az eszköz nem javítható / kalibrálható.
        </Text>
        <View style={[styles.row, worksheet.section]}>
          <View style={styles.col}>
            <Text>Commed Kft</Text>
            <Text>2890 Tata, Kocsi utca 17-19.</Text>
            <Text>10886854-2-11</Text>
          </View>
          <View style={styles.col}>
            <Text>Tel: +36 20 222 2626</Text>
            <Text>E-mail: info@muszeroazis.hu</Text>
            <Text>Web: www.muszeroazis.hu</Text>
          </View>
          <View style={styles.col}>
            <Text>K&H Bank Zrt.</Text>
            <Text>Számlaszám: 10404089-40817367-00000000</Text>
            <Text>IBAN: HU56 1040 4089 4081 7367 0000 0000</Text>
            <Text>SWIFT: OKHBHUHB</Text>
          </View>
        </View>
      </View>
    </Page>
  );

  return (
    <Viewer>
      {!loading ? (
        <Document>
          {page}
          <Page size="A4" style={styles.page}></Page>
          {page}
          <Page size="A4" style={styles.page}>
            <View>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>Commed Kft. Szerviz és Kalibrálási Vállalási Szabályzata</Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                Garancia: A garancia vállalás ideje az elvégzett munkára a 19/2014 (IV.29.) NGM. rendelet és a 151/2003/IX.22. Kormány rendelet szerint történik.
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                A garancia érvényesítése: A garanciális javításra való igényét a hiba bejelentésével telephelyünkön érvényesítheti a javítástól számított 30 napon belül. Ha a garanciális hibát nem
                jelenti be és a hibát nem javíttatja ki a garancia keretén belül, egyéb követelésre nem tarthat igényt.
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                Garancia megszűnése: a garancia idő lejárta, a készülék megbontása, szakszerűtlen kezelés, elemi kár, hálózati feszültségingadozás, vagy egyéb, a javítással nem összefüggő ok esetén.{" "}
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                Garanciális javítás: a garanciális javítást telephelyünkön, 15 napon belül elvégezzük. Ha az alkatrészszállító az alkatrészt nem szállítja le időben, a javítás elhúzódik. Az alkatrész
                szállító késedelme miatt nem vállalunk felelősséget. A garancia idő meghosszabbodik a javításhoz szükséges idővel, fődarab esetén a garancia újra kezdődik. Garancia csak és kizárólag
                beépített alkatrészre vonatkozik. Nincs garancia a következőkre: hozott alkatrész beépítése esetén, biztosítékcsere, mechanikai sérülés, integrált áramkörök újbóli halmozott
                tönkremenetelére - ha nem volt egyben tápjavítás is (ilyen hibát csak gondatlan használat, vagy a tápegység hibája okozhat). AZ OLYAN HIBÁRA, AMELY ÁTADÁSKOR NEM LETT BEJELENTVE ÉS
                EZÉRT NEM LETT KIJAVÍTVA, SEMMILYEN UTÓLAGOS REKLAMÁCIÓT NEM FOGADUNK EL! Az olyan hibákra, amelyeket Ön bejelentett, de HIBAJELENSÉG HÍJÁN, vagy egyéb okból nem javítottunk és így nem
                is számláztunk, tehát Önnek nem kellett kifizetnie, garanciát értelemszerűen nem vállalunk és reklamációt utólag semmilyen formában nem fogadunk el. Az ilyen hibákat utólag is fizető
                javítással javítjuk. Az előbbi szélsőséges eseteken kívül, hibáknál garanciális javításokat a lehető leggyorsabban az Ön érdekei szerint végezzük el.
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                Javítás: a készüléket az átvétel után átvizsgáljuk. Sok esetben a hiba tényleges oka, vagy a rejtett hibák csak a javítás folyamán derülnek ki, A javításhoz esetleg alkatrészszállító
                által adott határidő nem teljesül, a javításra adott határidőt nem tudjuk betartani. Határidő módosulás lehet akkor is, ha pl. csak a javítás során derül ki valamilyen rejtett hiba,
                amelynek a javításához, előre nem felbecsülhető idő szükséges. Ilyenkor újbóli időpont egyeztetést javasolunk. Ha a javítási díj 50%-kal több mint az első irányár, az Ön érdekében csak
                újbóli egyeztetés után folytatjuk a beszerzést és a javítást. Ha alkatrészrendelésre kerül sor és az alkatrész ritka, vagy speciális, a beszerzésre 60% előleget kérünk. Amennyiben ez
                utólag történik, a beszerzést az előleg megérkezése után kezdjük meg. Az előleget elfogadjuk készpénzben vagy átutalással is. Amennyiben a hiba megállapítása után ügyfelünk nem kéri a
                javítást, bevizsgálási költséget számolunk fel.
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>
                Kalibrálás: Kalibrálásra átadott készüléken a kalibrálást abban az esetben végezzük el, ha a készülék kalibrálása alkalmas állapotban van. Abban az esetben, ha az adott készülék nincs
                kalibrálása alkalmas állapotban, úgy a Vevő kérésére szervizünk végrehajtja a szükséges javításokat. Amennyiben ezt a Vevő nem vállalja, a kalibrálást visszautasítjuk és bevizsgálási
                költséget számolunk fel. Minősítést kizárólag a vevő által írásban átadott specifikáció alapján végzünk. Kalibrálást csak írásos megrendelés alapján végzünk. A kalibrálások teljesítése
                során folyamatosan biztosítjuk pártatlanságunkat, ennek gyanúja esetén a kalibrálást visszautasítjuk. Nem vállaljuk a javítást: Ha Ön nem kéri az összes szükséges javítást, az így
                fennmaradó hiba a javított vagy egyéb részekben zavart okozhat, a rendeltetésszerű használatot nem teszi lehetővé, és/vagy későbbi reklamációra adhat okot. AMENNYIBEN A KÉSZÜLÉK
                SZÉTSZERELVE, BEFEJEZETLEN ÉS/VAGY SZAKSZERŰTLEN JAVÍTÁSI NYOMOKKAL ÉRKEZIK A KALIBRÁLÁST NEM VÁLLALJUK. Ha a szakszerűtlen beavatkozás csak a javítás vagy átvizsgálás során derül ki,
                akkor is az előbbiek szerint vállaljuk a javítást. A fentiek esetén a javítás befejezése akár hónapokig is elhúzódhat. Az ilyen készüléket bármikor visszaadjuk, a beépített alkatrészek
                ára, valamint az addig elvégzett munka dija ellenében. Tárolási díjat ilyenkor nem számítunk fel, valamint nem fogadunk el semmilyen reklamációt a javítási időre, vagy a félbehagyott
                javításra. A javítást bármikor visszamondhatja, ilyenkor bevizsgálási díjat számítunk fel. Felszámítjuk továbbá a beépített alkatrészeket és munkadíjat, ha a határidő előtt mondta
                vissza a javítást.
              </Text>
              <Text style={{ textAlign: "justify", marginBottom: 5 }}>Érvényes: 2020.01.01-től</Text>
            </View>
          </Page>
        </Document>
      ) : (
        ""
      )}
    </Viewer>
  );
}
